import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
class ScrollToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // Delay nhẹ để đảm bảo content đã render xong trước khi cuộn
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 200); // 100ms là ổn, bạn có thể điều chỉnh nếu cần
    }
  }

  render() {
    return <></>;
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ScrollToTop)
);
